module.exports = __webpack_public_path__ + "4fdd0237c663acf01da7a6a70c6b87d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-29.png
// module id = 1610
// module chunks = 0